// extracted by mini-css-extract-plugin
export default {"actions":"More_actions__GxBu9","active":"More_active__pn6GP","button":"More_button__5rWsy","body":"More_body__GwKjF","item":"More_item__K57rs"};